import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@clerk/clerk-react'
import { useApiClient } from '@/shared/api'

interface MeResponse {
  userId: string
  orgId: string
  companyId: number
  role: string
  isSuperadmin: boolean
  email: string
}

/**
 * Hook to check if the current user is a superadmin
 * Returns the superadmin status from the API
 */
export function useIsSuperadmin() {
  const apiClient = useApiClient()
  const { isSignedIn } = useAuth()

  const query = useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      return apiClient<MeResponse>('/me')
    },
    enabled: isSignedIn,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: false,
  })

  return {
    isSuperadmin: query.data?.isSuperadmin ?? false,
    isLoading: query.isLoading,
    data: query.data,
  }
}